import DetectMobileBrowsers from '../../utils/detect-mobile-browsers';
import Popup from '../../utils/popup';
import Tools from '../../utils/tools';

class ListaTowarow {
    constructor() {
        this.noTermsInfo = $('#no-terms-info');
        this.eventsList = $('#events-list');
        this._layout = '';
        this.isMobileBrowser = DetectMobileBrowsers.check();
        this.productSearchParams = {
            pagesize: parseInt(this.getUrlParameter('pagesize', 12)), //ilość produktów na stronie
            sort: this.getUrlParameter('sort', sortowanieParam), // rodzaj sortowania, domyślnie stała: IKSORIS_TOWAR_SORT_NAZWA = 0
            p: parseInt(this.getUrlParameter('p', 1)), // numer strony
            q: this.getUrlParameter('q', ''), //szukana fraza
            cat: parseInt(this.getUrlParameter('cat', 0)) //id kategorii
        };

        if (typeof pageLayout !== 'undefined' && pageLayout === 'list') {
            $('.special__products').removeClass('special__products--grid').addClass('special__products--list');
            $('.special__products > .row').isotope({
                layoutMode: 'vertical'
            });
            this.layout = 'list';
        }

        if ($('body').hasClass('rezerwacja-uzytkownik-ulubione') && pageLayout === 'grid') {
            this.matchBoxesHeightPolka();
        }
    }

    get layout() {
        return this._layout;
    }

    set layout(value) {
        if (this.layout !== value) {
            this._layout = value;
            this.changeLayout(this.layout);
        }
    }

    events() {
        const _this = this;
        $('.removeFav').on('click', function(e) {
            e.stopPropagation();
            let iksorisId = parseInt($(this).data('iksoris_towar_id'));
            _this.usunZPolki(iksorisId);
        });
        $('.product__item').on('click', function() {
            if ($('body').hasClass('rezerwacja-uzytkownik-biblioteka') === false) {
                let towarCmsId = $(this).data('towarcms_id');

                if (towarCmsId) {
                    document.location.href = '/towary/szczegoly.html?id=' + towarCmsId;
                } else {
                    let popup = new Popup('Towar jeszcze nie jest gotowy do sprzedaży,<br />oczekuje na uzupełnienie opisów, dodanie zdjęć oraz zatwierdzenie');
                    popup.showPopup();
                }
            }
        });

        //$(".butik-showperpage select").change(function () {
        //    let nowaIlosc = parseInt($(this).val());
        //    _this.changePageQty(nowaIlosc);
        //});
        //
        //$('#sortby').change(function(){
        //    let sort = $(this).val();
        //    _this.changeSort(sort);
        //});

        $('select#sortby').on('change', function() {
            _this.productSearchParams.p = 1;
            _this.productSearchParams.sort = $(this).val();
            _this.reloadPage();
        });

        $('select#page-item-count').on('change', function() {
            _this.productSearchParams.p = 1;
            _this.productSearchParams.pagesize = $(this).val();
            _this.reloadPage();
        });

        $('li.page-item a').on('click', function(e) {
            e.preventDefault();
            let selectedPage;
            if ($(this).hasClass('page-link_prev')) {
                selectedPage = parseInt($('.page-item.active a').data('page_number'));
                selectedPage--;
            } else if ($(this).hasClass('page-link_next')) {
                selectedPage = parseInt($('.page-item.active a').data('page_number'));
                selectedPage++;
            } else {
                selectedPage = parseInt($(this).data('page_number'));
            }
            _this.productSearchParams.p = selectedPage;
            _this.reloadPage();
        });

        $('.butik-changeview__icon--row').on('click', function() {
            $('.special__products').removeClass('special__products--list').addClass('special__products--grid');
            $('.special__products > .row').isotope({
                layoutMode: 'fitRows'
            });
            _this.layout = 'grid';
        });

        $('.butik-changeview__icon--list').on('click', function() {
            $('.special__products').removeClass('special__products--grid').addClass('special__products--list');
            $('.special__products > .row').isotope({
                layoutMode: 'vertical'
            });
            _this.layout = 'list';
        });

        $('.special__products > .row').on('arrangeComplete', function(event, filteredItems) {
            _this.matchBoxesHeight();
        });

        $('.download-btn').on('click', function() {
            let buttonData = $(this).data();
            _this.downloadFile(buttonData);
        });
    }

    matchBoxesHeight() {
        $('.special__products > .row > div').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }

    matchBoxesHeightPolka() {
        $('.product__item__image').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
        $('.product__item__header').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
        $('.product__item__content').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }

    reloadPage() {
        const _this = this;
        let url = window.location.href;
        $.each(_this.productSearchParams, function(index, value) {
            url = _this.updateURLParameter(url, index, value);
        });

        window.location.replace(url);
    }

    getFileToDownloadData(buttonData) {
        const _this = this;

        $.ajax({
            url: '/uzytkownik/biblioteka.html?ajax=getFileInfo',
            method: 'get',
            data: buttonData,
            success: function(result) {
                console.log(result);
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    downloadFile(buttonData) {
        const _this = this;

        $.ajax({
            url: '/uzytkownik/biblioteka.html?ajax=downloadFile',
            method: 'get',
            data: buttonData,
            xhrFields: {
                responseType: 'blob' // to avoid binary data being mangled on charset conversion
            },
            beforeSend: Tools.preloaderShow,
            complete: function() {
                //$('#loading').hide();
                Tools.preloaderHide();
                $('button[data-iksoris_towar_id="' + buttonData.iksoris_towar_id + '"]').blur();
            },
            success: function(blob, status, xhr) {
                //console.error(blob, status, xhr);
                var filename = '';
                var disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    var URL = window.URL || window.webkitURL;
                    var downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                        // use HTML5 a[download] attribute to specify filename
                        var a = document.createElement('a');
                        // safari doesn't support this yet
                        if (typeof a.download === 'undefined') {
                            window.location.href = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                    } else {
                        window.location.href = downloadUrl;
                    }

                    setTimeout(function() {
                        URL.revokeObjectURL(downloadUrl);
                    }, 100); // cleanup
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    //changePageQty(newQty) {
    //    const _this = this;
    //
    //    $.ajax({
    //        url: "/towary/index.html",
    //        method: "get",
    //        data: {
    //            nowaIloscNaStronie: newQty
    //        },
    //        success: function (result) {
    //            let reloadUrl = _this.updateURLParameter(window.location.href, "p", 1);
    //            window.location.replace(reloadUrl);
    //        },
    //        error: function (xhr, status, error) {
    //            console.error(status);
    //            console.error(error);
    //        }
    //    });
    //}

    //changeSort(newSortType) {
    //    const _this = this;
    //    $.ajax({
    //        url: "/towary/index.html",
    //        method: "get",
    //        data: {
    //            sort: newSortType
    //        },
    //        success: function (result) {
    //            let reloadUrl = _this.updateURLParameter(window.location.href, "p", 1);
    //            //window.location.replace(reloadUrl);
    //
    //        },
    //        error: function (xhr, status, error) {
    //            console.error(status);
    //            console.error(error);
    //        }
    //    });
    //}

    changeLayout(layout) {
        let ajaxUrl;
        if ($('body').hasClass('rezerwacja-uzytkownik-biblioteka')) {
            ajaxUrl = '/uzytkownik/biblioteka.html';
        } else {
            ajaxUrl = '/towary/index.html';
        }
        $.ajax({
            url: ajaxUrl,
            method: 'get',
            data: {
                ajax: 'saveLayout',
                products_layout: layout
            },
            success: function(result) {
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    updateURLParameter(url, param, paramVal) {
        let newAdditionalURL = '';
        let tempArray = url.split('?');
        let baseURL = tempArray[0];
        let additionalURL = tempArray[1];
        let temp = '';
        if (additionalURL) {
            tempArray = additionalURL.split('&');
            for (var i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = '&';
                }
            }
        }

        var rows_txt = temp + '' + param + '=' + paramVal;
        return baseURL + '?' + newAdditionalURL + rows_txt;
    }

    initIsotope() {
        $('.special__products > .row').isotope({
            itemSelector: '.special__products > .row > div',
            percentPosition: true,
            layoutMode: 'fitRows'
        });
    }

    getUrlParameter(sParam, defaultParameterValue) {
        let sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        let urlParameterValue = null;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                if (sParameterName[1] === undefined) {
                    urlParameterValue = true;
                } else {
                    urlParameterValue = decodeURIComponent(sParameterName[1]);
                }
            }
        }

        return urlParameterValue === null ? defaultParameterValue : urlParameterValue;
    }

    usunZPolki(towar_iksoris_id) {
        const _this = this;
        $.ajax({
            url: '/towary/szczegoly.html',
            method: 'get',
            beforeSend: Tools.preloaderShow,
            complete: Tools.preloaderHide,
            data: {
                json: true,
                ajax_action: 'usun_z_polki',
                towar_iksoris_id: towar_iksoris_id
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    let popup = new Popup(result.successMessage);
                    popup.onClose = function() {
                        Tools.preloaderShow();
                        window.location.reload();
                    };
                    popup.showPopup();
                } else {
                    let popup = new Popup(result.message || 'Wystąpił błąd podczas usuwania towaru z półki');
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                let popup = new Popup('Wystąpił błąd podczas usuwania towaru z półki');
                popup.showPopup();
                console.error(status);
                console.error(error);
            }
        });
    }

    init() {
        this.events();

        if (!this.isMobileBrowser) {
            this.initIsotope();
        }
    }
}

export default ListaTowarow;
